import 'tocca';
import LazyLoad from 'vanilla-lazyload';
import '@PROJECT_ROOT/assets/mobile/js/jquery/jquery.min';
import '@PROJECT_ROOT/assets/mobile/js/jquery/jquery.ui.custom.min'; // mora biti jer datepicker neradi ako se dva puta učita
import '@PROJECT_ROOT/assets/mobile/js/jquery/jquery.mobile.custom.min';
import '@PROJECT_ROOT/assets/mobile/js/jquery/jquery.storageapi.min';
import '@PROJECT_ROOT/assets/mobile/js/jquery/js.cookie.min';
import initializePartnerMessaging from '@PROJECT_ROOT/assets/shared/js/partnerMessaging';
import promoCodeInit from '@PROJECT_ROOT/assets/mobile/js/promoCode';
/**
 * Ovo je privremeno globalna varijabla, ali treba se refaktorirati na način da se import-a u skriptama gdje nam treba
 */
import '@PROJECT_ROOT/assets/mobile/js/lib';
import initializeNewTabLinks from '@PROJECT_ROOT/assets/shared/js/partner/newTabLinks';

$(initializeNewTabLinks);

window.tocca({
    useJquery: false,
    swipeThreshold: 40,
});

$(document).ready(() => {
    const $promoCode = $('#promoCode');
    if ($promoCode.data('show')) {
        promoCodeInit($promoCode.data('message'));
    }

    // Ako smo na frame servisu, toast poruke se prikazuju pri vrhu stranice
    if (document.getElementById('frameService')) {
        $('.toastWrap').css('top', 10);
    }
});

$(() => {
    // Lazy load slika tek kada uđu u viewport preglednika
    //
    // @see https://github.com/verlok/lazyload za dokumentaciju

    /* eslint-disable-next-line no-new */
    new LazyLoad({
        elements_selector: '.js-lazy-load-image',
        threshold: 50,
    });
});

$(initializePartnerMessaging);
